import * as Yup from 'yup';
import i18next from 'i18next';
import { ExerciseType, TrainingType } from '../../../../shared/utils/enums';

export const createTrainingPlanValidationSchema = () =>
  Yup.object().shape({
    trainings: Yup.array().of(
      Yup.object().shape({
        trainingKind: Yup.string().oneOf(Object.values(TrainingType)).required(),

        name: Yup.string().required(i18next.t('trainingPlanForm.trainingNameValidation')),

        workoutsPerWeek: Yup.number()
          .required(i18next.t('trainingPlanForm.workoutsPerWeekValidation'))
          .min(1, i18next.t('trainingPlanForm.workoutsPerWeekValidation'))
          .max(7, i18next.t('trainingPlanForm.workoutsPerWeekValidation')),

        workoutPause: Yup.number().when('trainingKind', {
          is: TrainingType.STRENGTH,
          then: (schema) =>
            schema
              .required(i18next.t('trainingPlanForm.workoutPauseValidation'))
              .min(10, i18next.t('trainingPlanForm.workoutPauseValidation'))
              .max(180, i18next.t('trainingPlanForm.workoutPauseValidation')),
          otherwise: (schema) => schema.notRequired(),
        }),

        enduranceTrainingType: Yup.object().when('trainingKind', {
          is: TrainingType.ENDURANCE,
          then: (schema) => schema.required(i18next.t('trainingPlanForm.enduranceTypeValidation')),
          otherwise: (schema) => schema.notRequired(),
        }),

        exercises: Yup.array()
          .when('trainingKind', {
            is: TrainingType.STRENGTH,
            then: (schema) => schema.min(1, i18next.t('trainingPlanForm.exerciseValidation')),
            otherwise: (schema) => schema,
          })
          .of(
            Yup.object().shape({
              exerciseType: Yup.string()
                .oneOf(Object.values(ExerciseType))
                .required(i18next.t('exerciseCard.validation.exerciseType')),

              name: Yup.string().required(i18next.t('exerciseCard.validation.name')),
              description: Yup.string()
                .required(i18next.t('exerciseCard.validation.description'))
                .test(
                  'not-empty-html',
                  i18next.t('exerciseCard.validation.description'),
                  (value) => value !== '<p><br></p>'
                ),

              sets: Yup.number().when('exerciseType', {
                is: (exerciseType: string) =>
                  exerciseType === ExerciseType.STATIC ||
                  exerciseType === ExerciseType.DYNAMIC,
                then: (schema) =>
                  schema
                    .required(i18next.t('exerciseCard.validation.lowerSets'))
                    .min(1, i18next.t('exerciseCard.validation.lowerSets')),
                otherwise: (schema) => schema.notRequired(),
              }),

              time: Yup.number().when(['unit', 'exerciseType'], {
                is: (unit: string, exerciseType: string) =>
                  exerciseType === ExerciseType.ENDURANCE ||
                  exerciseType === ExerciseType.STATIC ||
                  (exerciseType === ExerciseType.DYNAMIC && (unit === 'sec' || unit === 'min')),
                then: (schema) =>
                  schema
                    .required(i18next.t('exerciseCard.validation.lowerTime'))
                    .min(1, i18next.t('exerciseCard.validation.lowerTime')),
                otherwise: (schema) => schema.notRequired(),
              }),

              repetition: Yup.number().when(['unit', 'exerciseType'], {
                is: (unit: string, exerciseType: string) =>
                  exerciseType === ExerciseType.DYNAMIC && unit === 'reps',
                then: (schema) =>
                  schema
                    .required(i18next.t('exerciseCard.validation.lowerRepetition'))
                    .min(1, i18next.t('exerciseCard.validation.lowerRepetition')),
                otherwise: (schema) => schema.notRequired(),
              }),
            })
          ),
      })
    ),
  });
